module.exports = __webpack_public_path__ + "img/minipro.fd49629e.jpg";